module.exports = __webpack_public_path__ + "img/headphone-1.6321b7f3.jpg";